import { Component, inject, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { HtmlUtilsService } from 'src/app/source/utils/html-utils.service';
import { Reactions } from '../reactions/interfaces/reactions.interface';

@Component({
  selector: 'app-universo-ahorramas-card',
  templateUrl: './universo-ahorramas-card.component.html',
  styleUrls: ['./universo-ahorramas-card.component.scss']
})
export class UniversoAhorramasCardComponent implements OnChanges {
  private htmlUtils = inject(HtmlUtilsService);
  private router: Router = inject(Router);


  @Input() id: number = 0;
  @Input() image: string = '';
  @Input() category: string = '';
  @Input() categoryBackgroundColor: string = '';
  @Input() categoryFontColor: string = '';
  @Input() title: string = '';
  @Input() date: string = '';
  @Input() dateInscription: string = '';
  @Input() content: string = '';
  @Input() openDate: string = '';
  @Input() endDate: string = '';
  @Input() maxEntries: string = '';
  @Input() allowedInscription: boolean = false;
  @Input() isUserRegistered: boolean = false;
  @Input() isSoldOut: boolean = false;
  @Input() location: string = '';
  @Input() reactions: Reactions;


  public textContent: string = '';

  ngOnChanges(): void {
    const withoutImage = this.htmlUtils.removeLeadingImage(this.content);
    const div = document.createElement('div');
    div.innerHTML = withoutImage;
    this.textContent = div.textContent?.trim() || '';
  }

  navigateToDetails() {
    console.log('id pinchadoo', this.id)
    this.router.navigate(['/noticia', this.id]);
  }
}
